import UpsLogo from 'images/zappos/ups-logo.svg';

import css from 'styles/components/account/returns/returnMethodBanner.scss';

const UPSBanner = () => (
  <div className={css.banner}>
    <img src={UpsLogo} alt="UPS" />
  </div>
);

export default UPSBanner;
